import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';

type AccountPeopleEmptyStateProps = {
  roleName?: string;
};
export const AccountPeopleEmptyState = ({
  roleName,
}: AccountPeopleEmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faUser}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          roleName ? (
            <FormattedMessage
              id="account.people.empty_state.no_people_with_role.title"
              values={{ roleName }}
            />
          ) : (
            <FormattedMessage id="account.people.empty_state.no_people.title" />
          )
        }
        message={
          <FormattedMessage id="account.people.empty_state.no_people.message" />
        }
      />
    </EmptyStateContainer>
  );
};
